import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import DefaultLayout from '../../layouts/Default'
import Quote from '../../components/Quote'
import BioImage from '../../assets/images/bio-drew.jpg'
import BioTravel1Image from '../../assets/images/bio-travel-1.jpg'

const Bio = () => {
  return (
    <DefaultLayout pageTitle="bio">
      <Container className="bio">
        <Row className="align-items-center">
          <Col md={5}>
            <img className="bio-image" src={BioImage} alt="a portrait shot of me" />
          </Col>
          <Col md={7}>
            <header>
              <h2>Small town beginnings</h2>
              <h3>Ever heard of Huntington, W.V.?</h3>
            </header>
            <p>You may have heard of Marshall University, the Mothman, or perhaps seen the documentary about the drug crisis. Luckily my parents moved my family to Florida at a young age.</p>
            <p>With the lack of opportunities (and sights of abandoned buildings and torn roads) the town I called home, gives me the drive to be the best version of myself. For this, I'm grateful for my small-town beginnings.</p>
          </Col>
        </Row>

        <Row className="bio-quote">
          <Col lg={10} xl={12} className="mx-auto">
            <Quote color="lime" source="Nichole - Amazon - Sr. Director, Digital CX, Lifecycle & Loyalty">
              "Drew has a natural gift for delivering this guidance in a respectful and productive way. I had the chance to watch Drew really refine his ability to guide stakeholders down the best path, even when it wasn’t their original path."
            </Quote>
          </Col>
        </Row>

        <Row className="align-items-center reverse">
          <Col>
            <header>
              <h2>A love for travel</h2>
              <h3>Showing my kids life is about adventure</h3>
            </header>
            <p>After studying Japanese for 4 years, I recently spent three weeks traveling solo through Japan. No real plan—just living in the moment. I spent late nights with new friends, sparred with retired sumo wrestlers, traveled to Mt. Fuji, and butchered a few karaoke songs.</p>
            <p>It's important for me to pass this perspective down to my kids. Not just the travel itself, but the openness that comes with it. To explore, to be uncomfortable, and to realize there’s always more out there than what you know today.</p>
            <p className="fst-italic">(Ask me about being kidnapped in the UK)</p>
          </Col>
          <Col>
            <img src={BioTravel1Image} alt="a portrait shot of me" />
          </Col>
        </Row>

        <Row className="bio-centered">
          <Col className="mx-auto">
            <header>
              <h2>Mentored ~100 designers</h2>
            </header>
            <p>In addition to my professional work, I am passionate about giving back to the community through mentoring aspiring designers at CareerFoundry and Thinkful, online bootcamps that offer specialized programs in UX design, UI design, and data analytics.</p>
            <div className='bio__quote-wrapper'>
              <Quote color="pink" source="Stacy - Cigna - UX Designer">
                "I am one of Drew's UX mentees at CareerFoundry, and he is the only reason I know what I'm doing at the bootcamp. He is driven, organized, fun, knowledgeable, and genuine. His love for his students and his desire to see them grow show in the countless hours he spends meeting with me weekly."
              </Quote>
              <Quote color="yellow" source="Alexandria - Superlanet - IT Manager">
                "Drew was hands down the best mentor I could've asked for during my time at Careerfoundry! Thanks to Drew's guidance, I've seen tremendous growth as a designer. His mentorship has been instrumental in shaping my journey and building my confidence in the field of UX design."
              </Quote>
            </div>
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  )
}

export default Bio;
